import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
import { IMAGES } from "../data/offer";
type Notice = {
  name: string;
  place: string;
  minutes: number;
  key: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  useEffect(() => {
    let hideTimer: number | undefined;
    let nextTimer: number | undefined;
    let last = -1;
    const show = () => {
      let idx = Math.floor(Math.random() * buyers.length);
      if (idx === last) idx = (idx + 1) % buyers.length;
      last = idx;
      setNotice({
        ...buyers[idx],
        minutes: 1 + Math.floor(Math.random() * 14),
        key: Date.now()
      });
      hideTimer = window.setTimeout(() => {
        setNotice(null);
        nextTimer = window.setTimeout(show, 9000);
      }, 5000);
    };
    nextTimer = window.setTimeout(show, 6000);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-196" data-mp="1175x65nuh6hf">
      <AnimatePresence data-id="element-197" data-mp="1fuhbugfbp6lr">
        {notice && <motion.div key={notice.key} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex max-w-sm items-center gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 pr-9 text-navy-900 shadow-[0_18px_40px_-12px_rgba(5,13,28,0.45)]" data-id="element-198" data-mp="1awphlfr7h8ee">
            <img src={IMAGES.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-199" data-mp="28kg22f5979s0" />
            <div className="min-w-0" data-id="element-200" data-mp="23lmybefrqx51">
              <p className="text-sm leading-snug" data-id="element-201" data-mp="23klg8q0c5adt">
                <strong data-id="element-202" data-mp="2aotjuc285thm">{notice.name}</strong> from {notice.place}
              </p>
              <p className="text-sm leading-snug text-navy-900/75" data-id="element-203" data-mp="2aqxjuix068cm">just purchased the Clinical Roadmap™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta-hover" data-id="element-204" data-mp="2kmr6ww8clk8n">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden data-id="element-205" data-mp="2plu09jeyu20s" /> Verified purchase · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setNotice(null)} aria-label="Close notification" className="absolute right-2 top-2 rounded-md p-1 text-navy-900/50 hover:text-navy-900" data-id="element-206" data-mp="1rzei0fept0c6">
              <XIcon className="h-4 w-4" data-id="element-207" data-mp="26mpv4lqjosee" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}